import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTagsCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "tags-check" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9,19.188a1.5,1.5,0,0,1-2.121,0L1.5,13.81a1.5,1.5,0,0,1,0-2.122L12,1.188A1.5,1.5,0,0,1,13.061.749h5.378a1.5,1.5,0,0,1,1.5,1.5V7.628a1.5,1.5,0,0,1-.439,1.06"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.189,4.124a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 16.939,
			cy: 17.249,
			r: 6
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M19.613,15.5l-2.905,3.874a.75.75,0,0,1-1.13.08l-1.5-1.5"
		})
	]
});
export default SvgTagsCheck;
